import type { GridValueFormatterParams } from "@mui/x-data-grid";
import { FLOAT_NUMBER_PRECISION } from "consts/general";

const financial = (params: GridValueFormatterParams<string>) => {
    const value = Number.parseFloat(params.value).toFixed(FLOAT_NUMBER_PRECISION);
    return value.toLocaleString();
};

export default financial;
